import { render } from "./ChevronUp.vue?vue&type=template&id=3a5cfa88"
import script from "./ChevronUp.vue?vue&type=script&lang=js"
export * from "./ChevronUp.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__